/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable no-bitwise */
import React, { useState, useEffect, useCallback, useContext } from 'react';
import {
  Route,
  Switch,
  useLocation,
  Redirect,
  useHistory,
} from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import './App.scss';
import TopBar from '../TopBar/TopBar';
import BottomBar from '../BottomBar/BottomBar';
import PersonalInfo from '../../pages/PersonalInfo/PersonalInfo';
import HouseholdInfo from '../../pages/HouseholdInfo/HouseholdInfo';
import HopesInfo from '../../pages/HopesInfo/HopesInfo';
import Results from '../../pages/Results/Results';
import Error from '../../pages/Error/Error';
import StepIndicator from '../StepIndicator/StepIndicator';
import useQuery from '../../utils/useQuery/useQuery';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';
import { getShowSendResults, getSchema } from '../../api/index';
import {
  LocaleContext,
  UserContext,
  PreviousPathContext,
} from '../../contexts';
import QueryProvider from '../Providers/QueryProvider';
import AnswersProvider from '../Providers/AnswersProvider';
import LanguageSelect from '../LanguageSelect/LanguageSelect';
import getConType from '../../utils/getConType/getConType';
import getUserPersonaType from '../../utils/getUserPersonaType/getUserPersonaType';
import getText from '../../assets/locale/locale';
import validTime from '../../utils/validTime/validTime';
import {
  LOCALE_EN_US,
  LOCALE_EN_CA,
  LOCALE_FR_CA,
  STARTING_POINT_APP_NAME_FRENCH,
} from '../../constants/constants';
import USER_PERSONA_TYPES from '../../constants/userPersonas';

const App = () => {
  // the query object is used to collect user given information. It will be sent over to the API in order to retrieve personalized results.
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState('/');
  const [schema, setSchema] = useState({});
  const [quizStarted, setQuizStarted] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [paramsFetched, setParamsFetched] = useState(false);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const [userPersona, setUserPersona] = useState(null);
  const [faInfo, setFaInfo] = useState({
    faFirstName: null,
    faLastName: null,
    branchNo: null,
    faNo: null,
    faPhoto: null,
  });
  const { previousPath } = useContext(PreviousPathContext);
  const [contactName, setContactName] = useState({});
  const [showSendToFa, setShowSendToFa] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const urlQuery = useQuery();
  const faNo = urlQuery.get('faNo');
  const conId = urlQuery.get('conId');
  const entityId = urlQuery.get('EID');
  const timestamp = urlQuery.get('creTS');
  const utmSource = urlQuery.get('utm_source');
  const utmContent = urlQuery.get('utm_content');
  const conType = getConType(utmSource, utmContent);
  const IEAgent =
    window.navigator.userAgent.indexOf('MSIE') !== -1 ||
    window.navigator.userAgent.indexOf('rv:') !== -1;

  const showSendResultsPersonaTypeArray = Array.of(
    USER_PERSONA_TYPES.WORD_POWER,
    USER_PERSONA_TYPES.NEWS_LETTER,
    USER_PERSONA_TYPES.PERSONAL_LINK,
    USER_PERSONA_TYPES.PERSONAL_LINK_FA_PROFILE
  );

  const locId = (() => {
    const localeRegex = /^(fr_(CA|ca))|(en_(US|us|CA|ca))$/;
    let locale = LOCALE_EN_US;

    if (urlQuery.get('locale')) {
      const localeQueryParam = urlQuery.get('locale');
      if (localeQueryParam.length === 5 && localeRegex.test(localeQueryParam)) {
        if (localeQueryParam.toLowerCase() === LOCALE_FR_CA.toLowerCase()) {
          locale = LOCALE_FR_CA;
        } else if (
          localeQueryParam.toLowerCase() === LOCALE_EN_CA.toLowerCase()
        ) {
          locale = LOCALE_EN_CA;
        } else if (
          localeQueryParam.toLowerCase() === LOCALE_EN_US.toLowerCase()
        ) {
          locale = LOCALE_EN_US;
        }
      }
    }

    if (window.location.href.includes('.ca')) {
      if (window.location.href.includes(STARTING_POINT_APP_NAME_FRENCH)) {
        locale = LOCALE_FR_CA;
      } else {
        locale = LOCALE_EN_CA;
      }
    }
    return locale;
  })();

  // Prevent React from recreating this function reference when re-rendering
  const handleBeforeUnload = useCallback((event) => {
    event.preventDefault();
  }, []);

  const removeBeforeUnloadEventListener = () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };

  const addBeforeUnloadEventListener = () => {
    window.addEventListener('beforeunload', handleBeforeUnload);
  };

  const isSendToFAButtonDisplayed = (showResults) =>
    showResults &&
    userPersona !== USER_PERSONA_TYPES.WEBSITE_PROSPECT &&
    (!conId || (conId && validTime(timestamp)));

  useEffect(() => {
    const faNumber = urlQuery.get('faNo');
    const entityID = urlQuery.get('EID');
    const contactID = urlQuery.get('conId');
    const createTimeStamp = urlQuery.get('creTS');
    const contactType = !urlQuery.get('conType')
      ? getConType(utmSource, utmContent)
      : urlQuery.get('conType');

    // @TODO: convert logic to something more expandable for future locale ids.
    setSessionId(generateUUID());
    setParamsFetched(true);
    setUserPersona(
      getUserPersonaType(
        faNumber,
        entityID,
        contactID,
        contactType,
        createTimeStamp,
        utmSource,
        locId
      )
    );

    addBeforeUnloadEventListener();
    return () => {
      removeBeforeUnloadEventListener();
    };
  }, []);

  useEffect(() => {
    if (paramsFetched) {
      initialFetch();
    }
  }, [paramsFetched]);

  const initialFetch = () => {
    let isCancelled = false;
    if (locId !== '') {
      // only call the schema endpoint once a locId has been set
      getSchema(locId)
        .then((res) => {
          if (!isCancelled) {
            if (typeof res === 'object' && JSON.stringify(res) !== '{}') {
              // check that response is not an empty string or empty object
              setSchema(res);
              if (showSendResultsPersonaTypeArray.includes(userPersona)) {
                getShowSendResults(
                  faNo,
                  conId,
                  entityId,
                  locId,
                  conType,
                  utmSource
                ).then((data) => {
                  if (data.faInfo) {
                    setFaInfo(data.faInfo);
                  }
                  if (data.contactFirstName) {
                    setContactName({
                      firstName: data.contactFirstName,
                      lastName: data.contactLastName,
                    });
                  }
                  if (isSendToFAButtonDisplayed(data.showSendResults)) {
                    setShowSendToFa(true);
                  }
                  fireEvents(data);
                  setLoading(false);
                });
              } else {
                fireEvents(null);
                setLoading(false);
              }
            } else {
              setErrorOccurred(true);
              history.push({
                pathname: getText(locId, 'AllPages', 'errorPath', 'App'),
                search: location.search,
              });
            }
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          setErrorOccurred(true);
          history.push({
            pathname: getText(locId, 'AllPages', 'errorPath', 'App'),
            search: location.search,
          });
        });
    }
    return () => {
      isCancelled = true;
    };
  };

  const fireEvents = (data) => {
    addDataLayerTrigger('dataLayer-initialized', {
      page_type: 'personalInfoPage',
      locale: locId,
      environment: window.ENVIRONMENT,
      sessionid: sessionId ?? undefined,
      fa_no: data?.faInfo?.faNo ?? undefined,
      fa_entity_id: data?.faInfo?.entityIdBase64 ?? undefined,
    });

    addDataLayerTrigger('VirtualPageview', {
      page_path: window.location.pathname,
      page_title: document.title,
      page_referrer: previousPath,
      external_referrer:
        window.document.referrer && window.document.referrer.trim() !== ''
          ? window.document.referrer
          : undefined,
      page_url: window.location.href,
    });
  };

  const generateUUID = () => {
    // explanation of logic here: https://medium.com/@adames/generating-unique-ids-4c18dcf26a79
    let time = new Date().getTime();
    if (
      typeof performance !== 'undefined' &&
      typeof performance.now === 'function'
    ) {
      time += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const random = (time + Math.random() * 16) % 16 | 0;
      time = Math.floor(time / 16);
      return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16);
    });
  };

  const steps = getText(locId, 'AllPages', 'steps', 'StepIndicator');
  const stepUrls = getText(locId, 'AllPages', 'stepUrls', 'StepIndicator');

  const routers = (
    <div>
      <Switch location={location}>
        <Route exact path={getText(locId, 'AllPages', 'personalPath', 'App')}>
          <PersonalInfo
            loading={loading}
            setCurrentStep={setCurrentStep}
            schema={schema}
            setQuizStarted={setQuizStarted}
            sessionId={sessionId}
          />
        </Route>
        <Route exact path={getText(locId, 'AllPages', 'householdPath', 'App')}>
          {quizStarted ? (
            <HouseholdInfo
              setCurrentStep={setCurrentStep}
              schema={schema}
              faInfo={faInfo}
              sessionId={sessionId}
            />
          ) : (
            <Redirect
              to={{
                pathname: getText(locId, 'AllPages', 'personalPath', 'App'),
                search: location.search,
              }}
            />
          )}
        </Route>
        <Route exact path={getText(locId, 'AllPages', 'goalsPath', 'App')}>
          {quizStarted ? (
            <HopesInfo
              setCurrentStep={setCurrentStep}
              schema={schema}
              faInfo={faInfo}
              sessionId={sessionId}
            />
          ) : (
            <Redirect
              to={{
                pathname: getText(locId, 'AllPages', 'personalPath', 'App'),
                search: location.search,
              }}
            />
          )}
        </Route>
        <Route exact path={getText(locId, 'AllPages', 'resultsPath', 'App')}>
          {quizStarted ? (
            <Results
              setCurrentStep={setCurrentStep}
              sessionId={sessionId}
              setErrorOccurred={setErrorOccurred}
              showSendToFa={showSendToFa}
              faInfo={faInfo}
              contactName={contactName}
            />
          ) : (
            <Redirect
              to={{
                pathname: getText(locId, 'AllPages', 'personalPath', 'App'),
                search: location.search,
              }}
            />
          )}
        </Route>
        <Route exact path={getText(locId, 'AllPages', 'errorPath', 'App')}>
          {errorOccurred ? (
            <Error
              quizStarted={quizStarted}
              setQuizStarted={setQuizStarted}
              setErrorOccurred={setErrorOccurred}
            />
          ) : (
            <Redirect
              to={{
                pathname: getText(locId, 'AllPages', 'personalPath', 'App'),
                search: location.search,
              }}
            />
          )}
        </Route>
        <Route path="*">
          <Redirect
            to={{
              pathname: getText(locId, 'AllPages', 'personalPath', 'App'),
              search: location.search,
            }}
          />
        </Route>
      </Switch>
    </div>
  );

  return (
    <UserContext.Provider value={userPersona}>
      <LocaleContext.Provider value={locId}>
        <QueryProvider>
          <AnswersProvider>
            <div className="flex-wrapper">
              <div id="app-component" data-testid="content-wrapper">
                <LanguageSelect
                  addBeforeUnloadEventListener={addBeforeUnloadEventListener}
                  removeBeforeUnloadEventListener={
                    removeBeforeUnloadEventListener
                  }
                />
                <TopBar />
                <div className="content-wrapper">
                  <div className="content">
                    <StepIndicator
                      currentStep={currentStep}
                      steps={steps}
                      stepUrls={stepUrls}
                    />
                    {!IEAgent ? (
                      <TransitionGroup component="div">
                        <CSSTransition
                          key={location.key}
                          classNames="fade"
                          timeout={{ enter: 300, exit: 300 }}
                          mountOnEnter={false}
                          unmountOnExit
                        >
                          {routers}
                        </CSSTransition>
                      </TransitionGroup>
                    ) : (
                      <>{routers}</>
                    )}
                  </div>
                </div>
                <BottomBar />
              </div>
            </div>
          </AnswersProvider>
        </QueryProvider>
      </LocaleContext.Provider>
    </UserContext.Provider>
  );
};

export default App;
